import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';

import type { TInput } from './models';

export const Input: FC<TInput> = ({
    CrossMIcon,
    MagnifierMIcon,
    PureInput,
    className = '',
    dataTestId = 'input',
    disabled,
    error,
    forwardedRef,
    id,
    name = 'search',
    onBlur,
    onChange,
    onClear,
    onFocus,
    placeholder,
    styles,
    value = '',
}) => {
    return (
        <div className={cn(styles.inputWrapper, className)}>
            <span className={styles.searchIcon}>
                <MagnifierMIcon />
            </span>
            <label className={styles.label} htmlFor={id}>
                <PureInput
                    className={cn(className, styles.external, styles.inputElement)}
                    dataTestId={dataTestId}
                    disabled={disabled}
                    error={error}
                    forwardedRef={forwardedRef}
                    hasFloatingLabel={Boolean(placeholder)}
                    id={id}
                    name={name}
                    onBlur={onBlur}
                    onChange={onChange}
                    onFocus={onFocus}
                    value={value}
                />
                <span
                    className={cn(styles.placeholder, {
                        [styles.emptyValue]: value === '',
                    })}
                >
                    {placeholder}
                </span>
            </label>
            {value && (
                <button
                    className={styles.clear}
                    data-test-id="clear-button"
                    onClick={onClear}
                    type="button"
                >
                    <CrossMIcon data-test-id={`clear-icon-${name}`} />
                </button>
            )}
        </div>
    );
};
